var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors;
  return {
    alertPadding: spacing.medium,
    alertZIndex: '8888',
    containerPadding: spacing.medium,
    disabledChildrenBackgroundColor: colors.contrasts.grey1111,
    disabledChildrenOpacity: '0.6',
    disabledChildrenZIndex: '7777'
  };
};
export default generateComponentTheme;